import { registerPlugin } from "@capacitor/core";
import { isTurkishIos } from "../lib/native.ts";
import type { AppleCredential } from "../lib/session.ts";
import { messages } from "../i18n/index.ts";

const appleSignIn = registerPlugin<{ signIn(): Promise<AppleCredential> }>("AppleSignIn");

interface AppleSignInButtonProps {
  onCredential: (credential: AppleCredential) => void;
  /** Kullanıcı vazgeçmedi ama giriş olmadı. */
  onError?: () => void;
  disabled?: boolean;
}

/**
 * "Apple ile devam et" — yalnızca iOS uygulamasında. App Store kuralı Google
 * girişi sunan uygulamada bunu da istiyor; görünümü Apple'ın düğme kurallarına
 * uygun: siyah zemin, Apple logosu, Google düğmesiyle aynı boyda ve ondan önce.
 */
export function AppleSignInButton({ onCredential, onError, disabled = false }: AppleSignInButtonProps) {
  if (!isTurkishIos()) return null;
  return (
    <button
      type="button"
      className="mb-3 flex w-full items-center justify-center gap-2 rounded-lg bg-black px-4 py-3 text-base font-semibold text-white disabled:opacity-50"
      disabled={disabled}
      onClick={() => {
        void appleSignIn.signIn().then(onCredential).catch((error: unknown) => {
          if ((error as { message?: string })?.message !== "cancelled") onError?.();
        });
      }}
    >
      <svg aria-hidden="true" viewBox="0 0 17 20" width="16" height="19" fill="currentColor">
        <path d="M14.1 10.6c0-2.4 2-3.6 2.1-3.7-1.1-1.7-2.9-1.9-3.5-1.9-1.5-.2-2.9.9-3.7.9-.8 0-1.9-.9-3.2-.8-1.6 0-3.1 1-4 2.4-1.7 3-.4 7.3 1.2 9.7.8 1.2 1.8 2.5 3 2.4 1.2 0 1.7-.8 3.1-.8 1.5 0 1.9.8 3.2.8 1.3 0 2.1-1.2 2.9-2.4.9-1.4 1.3-2.7 1.3-2.8 0 0-2.4-.9-2.4-3.8zM11.7 3.5c.7-.8 1.1-1.9 1-3-1 0-2.1.7-2.8 1.5-.6.7-1.2 1.8-1 2.9 1 .1 2.1-.6 2.8-1.4z" />
      </svg>
      {messages.profile.appleButton}
    </button>
  );
}
